import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Modal from "react-modal";
import Renewals from "../renewals-incentive-tabs/Renewals";
import {
  fetchAllRenewalsData,
  fetchAllSalesReportByFilterTypeData,
} from "../../../redux/reducers/apiSlice";
import ExpiringMemberships from "./ExpiringMemberships";
import moment from "moment";
import { BodyBuilder } from "../../../exports/Images";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { selectAuth } from "../../auth/auth.selector";

const RenewalTabs = ({ selectedGyms, daysFilter }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { salesReportsBuFiltertypeData, allRenewalsData } = useSelector(
    (state) => state.api
  );
  const filterTypes = [
    " ",
    "expire_today",
    "expire_month",
    "unpaid",
    "all_renewals",
  ];
  const initialRenewalsData = {
    pageNo: 0,
    allRenewalsData: [],
    totalData: null,
    renewalsPagination: [],
    totalMembers: 0,
  };
  const [allRenewals, setAllRenewals] = useState(initialRenewalsData);
  const initialRenewalFilters = {
    searchString: "",
  };
  const [renewalFilters, setRenewalFilters] = useState(initialRenewalFilters);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [imageModal, setImageModal] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const [searchBtnClicked, setSearchBtnClicked] = useState(false);

  const handleTabSelect = (index) => {
    setAllRenewals(initialRenewalsData);
    setSelectedTabIndex(index);

    setRenewalFilters(initialRenewalFilters);
    setSearchBtnClicked(false);
  };

  const searchQueryParam = renewalFilters.searchString
    ? `&search=${renewalFilters.searchString}`
    : "";
  const selectedGymQueryParam =
    decryptedText?.account_type !== "admin"
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : decryptedText?.account_type === "admin" && selectedGyms?.value
      ? `&gym_id=${selectedGyms.value}`
      : "";
  const startDateQueryParam =
    daysFilter?.startDate && daysFilter?.endDate
      ? `&start_date=${daysFilter.startDate}&end_date=${daysFilter.endDate}`
      : daysFilter?.startDate
      ? `&start_date=${daysFilter.startDate}`
      : daysFilter?.endDate
      ? `&end_date=${daysFilter.endDate}`
      : "";
  const queryParametersFor = `${selectedGymQueryParam}${startDateQueryParam}`;

  const onClickSearch = () => {
    setSearchBtnClicked(true);
    setAllRenewals((prevs) => ({ ...prevs, pageNo: 0 }));

    if (selectedTabIndex && filterTypes[selectedTabIndex] === "all_renewals") {
      dispatch(
        fetchAllRenewalsData({
          pageNo: allRenewals.pageNo + 1,
          queryParameters: queryParametersFor,
          searchQuery: searchQueryParam,
          token: decryptedText?.token,
        })
      );
    } else if (
      selectedTabIndex &&
      filterTypes[selectedTabIndex] === "expire_today"
    ) {
      dispatch(
        fetchAllSalesReportByFilterTypeData({
          pageNo: allRenewals.pageNo + 1,
          filterType: "expire_today",
          queryParameters: queryParametersFor,
          searchQuery: searchQueryParam,
          token: decryptedText?.token,
        })
      );
    } else if (
      selectedTabIndex &&
      filterTypes[selectedTabIndex] === "expire_month"
    ) {
      dispatch(
        fetchAllSalesReportByFilterTypeData({
          pageNo: allRenewals.pageNo + 1,
          filterType: "expire_month",
          queryParameters: queryParametersFor,
          searchQuery: searchQueryParam,
          token: decryptedText?.token,
        })
      );
    } else if (selectedTabIndex && filterTypes[selectedTabIndex] === "unpaid") {
      dispatch(
        fetchAllSalesReportByFilterTypeData({
          pageNo: allRenewals.pageNo + 1,
          filterType: "unpaid",
          queryParameters: queryParametersFor,
          searchQuery: searchQueryParam,
          token: decryptedText?.token,
        })
      );
    }
  };

  useEffect(() => {
    if (
      selectedTabIndex &&
      (filterTypes[selectedTabIndex] === "expire_today" ||
        filterTypes[selectedTabIndex] === "expire_month" ||
        filterTypes[selectedTabIndex] === "unpaid")
    ) {
      dispatch(
        fetchAllSalesReportByFilterTypeData({
          pageNo: allRenewals.pageNo + 1,
          filterType: filterTypes[selectedTabIndex],
          queryParameters: queryParametersFor,
          searchQuery: searchQueryParam,
          token: decryptedText?.token,
        })
      );
    }

    if (selectedTabIndex && filterTypes[selectedTabIndex] === "all_renewals") {
      dispatch(
        fetchAllRenewalsData({
          pageNo: allRenewals.pageNo + 1,
          queryParameters: queryParametersFor,
          token: decryptedText?.token,
        })
      );
    }
  }, [selectedTabIndex, allRenewals.pageNo, queryParametersFor]);

  useEffect(() => {
    if (salesReportsBuFiltertypeData?.status) {
      setAllRenewals({
        ...allRenewals,
        allRenewalsData:
          salesReportsBuFiltertypeData?.data?.length > 0
            ? salesReportsBuFiltertypeData.data
            : [],
        totalData: salesReportsBuFiltertypeData?.total
          ? salesReportsBuFiltertypeData.total
          : 0,
        renewalsPagination:
          salesReportsBuFiltertypeData?.pagination?.length > 0
            ? salesReportsBuFiltertypeData.pagination
            : [],
        totalMembers:
          salesReportsBuFiltertypeData?.pagination?.length > 0
            ? salesReportsBuFiltertypeData?.pagination?.[0]?.pagination
            : 0,
      });
    }
  }, [salesReportsBuFiltertypeData]);

  useEffect(() => {
    if (allRenewalsData?.status && allRenewalsData?.data) {
      setAllRenewals({
        ...allRenewals,
        allRenewalsData:
          allRenewalsData.data?.newSubs?.length > 0
            ? allRenewalsData.data.newSubs
            : [],
        totalData: allRenewalsData.data?.allRenews
          ? allRenewalsData.data.allRenews
          : 0,
        renewalsPagination:
          allRenewalsData.data?.pagination?.length > 0
            ? allRenewalsData.pagination
            : [],
        totalMembers:
          allRenewalsData.data?.pagination?.length > 0
            ? allRenewalsData.data?.pagination?.[0]?.pagination
            : 0,
      });
    }
  }, [allRenewalsData]);

  useEffect(() => {
    if (searchBtnClicked && renewalFilters.searchString?.length === 0) {
      if (
        selectedTabIndex &&
        filterTypes[selectedTabIndex] === "all_renewals"
      ) {
        dispatch(
          fetchAllRenewalsData({
            pageNo: allRenewals.pageNo + 1,
            queryParameters: queryParametersFor,
            token: decryptedText?.token,
          })
        );
      } else if (
        selectedTabIndex &&
        filterTypes[selectedTabIndex] === "expire_today"
      ) {
        dispatch(
          fetchAllSalesReportByFilterTypeData({
            pageNo: allRenewals.pageNo + 1,
            filterType: "expire_today",
            queryParameters: queryParametersFor,
            token: decryptedText?.token,
          })
        );
      } else if (
        selectedTabIndex &&
        filterTypes[selectedTabIndex] === "expire_month"
      ) {
        dispatch(
          fetchAllSalesReportByFilterTypeData({
            pageNo: allRenewals.pageNo + 1,
            filterType: "expire_month",
            queryParameters: queryParametersFor,
            token: decryptedText?.token,
          })
        );
      } else if (
        selectedTabIndex &&
        filterTypes[selectedTabIndex] === "unpaid"
      ) {
        dispatch(
          fetchAllSalesReportByFilterTypeData({
            pageNo: allRenewals.pageNo + 1,
            filterType: "unpaid",
            queryParameters: queryParametersFor,
            token: decryptedText?.token,
          })
        );
      }

      setSearchBtnClicked(false);
    }
  }, [renewalFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  const tablesColumns = [
    {
      dataField: "profile",
      text: "Member Profile",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.profile || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
            onClick={() => {
              setViewImage(row?.profile || BodyBuilder);
              setImageModal(true);
            }}
          />

          <div className="">
            <p
              className="name"
              style={{
                fontSize: "12px",
                color: "gray",
              }}
            >
              TRX ID - {row?.trx_id || "N/A"}
            </p>
            <p className="name">{row?.name || "N/A"}</p>
            <p className="name">{row?.mobile || "N/A"}</p>
            {row?.email ? (
              <p className="name" style={{ textTransform: "lowercase" }}>
                {row.email || "N/A"}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span
            className="tableData minWidth150"
            style={{
              border: "1px solid lightgrey",
              borderRadius: "4px",
            }}
          >
            {row?.gym_name || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "Plan Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              background: "#EEF5FF",
              color: "#7C93C3",
            }}
          >
            {(row?.type === "addon_pt" ? "addon" : row.type) || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              background: "#F4D3D3",
              color: "#F24C3D",
            }}
          >
            {row?.plan_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              background: "#E1ECC8",
              color: "#17594A",
            }}
          >
            ₹{row?.price || "0"}
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Subscription Added Date",
      formatter: (cell, row) => {
        const dateAdded = row?.date_added;
        const formattedDate = dateAdded
          ? moment(parseInt(dateAdded, 10))
              .tz("Asia/Kolkata")
              .format("DD-MM-YYYY")
          : "-";

        return (
          <div className="emeberDetailsRowContainer column minWidth90">
            <p className="name">{formattedDate}</p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Plan Start Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column minWidth90">
          <p className="name badge text-info font-weight-bold">
            {row?.start_date
              ? moment(row.start_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Plan Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column minWidth90">
          <p className="name">
            {row?.expire_date
              ? moment(row.expire_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Transaction Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">
            {(row.is_partial === "true" ? "Partial" : "Full") || "N/A"}
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(false)}
        contentLabel="Discussion Brief Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose title=" " onClose={() => setImageModal(false)} />
          <div className="discussionModalMessage">
            <img
              src={viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
              }}
            />
          </div>
        </div>
      </Modal>

      <div className="renewlasTabContainer" style={{ marginBottom: "20px" }}>
        <Tabs onSelect={handleTabSelect}>
          <TabList>
            <Tab>All Expiring Members Within 30 days</Tab>
            <Tab>Expiring Today</Tab>
            <Tab>Expiring This Month</Tab>
            <Tab>Unpaid Members</Tab>
            <Tab>All New Subscriptions</Tab>
          </TabList>
          <TabPanel>
            <Renewals selectedGyms={selectedGyms} daysFilter={daysFilter} />
          </TabPanel>
          <TabPanel>
            <ExpiringMemberships
              tableData={allRenewals.allRenewalsData}
              tableColumns={tablesColumns}
              tablePagination={allRenewals.renewalsPagination}
              isPage={allRenewals.pageNo}
              setIsPage={(value) =>
                setAllRenewals((prevData) => ({
                  ...prevData,
                  pageNo: value,
                }))
              }
              total={allRenewals.totalData}
              selectedTab={filterTypes[selectedTabIndex]}
              searchString={renewalFilters.searchString}
              setSearchString={(value) =>
                setRenewalFilters((prevData) => ({
                  ...prevData,
                  searchString: value,
                }))
              }
              onClickSearch={onClickSearch}
              totalMembers={allRenewals.totalMembers}
            />
          </TabPanel>
          <TabPanel>
            <ExpiringMemberships
              tableData={allRenewals.allRenewalsData}
              tableColumns={tablesColumns}
              tablePagination={allRenewals.renewalsPagination}
              isPage={allRenewals.pageNo}
              setIsPage={(value) =>
                setAllRenewals((prevData) => ({
                  ...prevData,
                  pageNo: value,
                }))
              }
              total={allRenewals.totalData}
              selectedTab={filterTypes[selectedTabIndex]}
              searchString={renewalFilters.searchString}
              setSearchString={(value) =>
                setRenewalFilters((prevData) => ({
                  ...prevData,
                  searchString: value,
                }))
              }
              onClickSearch={onClickSearch}
              totalMembers={allRenewals.totalMembers}
            />
          </TabPanel>
          <TabPanel>
            <ExpiringMemberships
              tableData={allRenewals.allRenewalsData}
              tableColumns={tablesColumns}
              tablePagination={allRenewals.renewalsPagination}
              isPage={allRenewals.pageNo}
              setIsPage={(value) =>
                setAllRenewals((prevData) => ({
                  ...prevData,
                  pageNo: value,
                }))
              }
              total={allRenewals.totalData}
              selectedTab={filterTypes[selectedTabIndex]}
              searchString={renewalFilters.searchString}
              setSearchString={(value) =>
                setRenewalFilters((prevData) => ({
                  ...prevData,
                  searchString: value,
                }))
              }
              onClickSearch={onClickSearch}
              totalMembers={allRenewals.totalMembers}
            />
          </TabPanel>
          <TabPanel>
            <ExpiringMemberships
              tableData={allRenewals.allRenewalsData}
              tableColumns={tablesColumns}
              tablePagination={allRenewals.renewalsPagination}
              isPage={allRenewals.pageNo}
              setIsPage={(value) =>
                setAllRenewals((prevData) => ({
                  ...prevData,
                  pageNo: value,
                }))
              }
              total={allRenewals.totalData}
              selectedTab={filterTypes[selectedTabIndex]}
              searchString={renewalFilters.searchString}
              setSearchString={(value) =>
                setRenewalFilters((prevData) => ({
                  ...prevData,
                  searchString: value,
                }))
              }
              onClickSearch={onClickSearch}
              totalMembers={allRenewals.totalMembers}
            />
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default RenewalTabs;
